import { CmmConfig } from '../../types/sharedTypeImpl.ts';

type ReadMetadataResult = {
    success: false,
    errorMessage: string
} | {
    success: true,
    firstPositionsRow: number,
    hasMultipleParts: boolean
};


export function readCmmMetadata(
    table: string[][],
    cmmConfig: CmmConfig
): ReadMetadataResult {
    if (cmmConfig.metadataRows < 1 || cmmConfig.validationCells.length < 1) {
        // No metadata defined
        return {
            success: true,
            firstPositionsRow: 0,
            hasMultipleParts: false
        };
    }

    const { foundMetadata, lastMetadataStart, hasMultipleParts } = findMetadata(cmmConfig, table);
    if (foundMetadata) {
        return {
            success: true,
            firstPositionsRow: lastMetadataStart! + cmmConfig.metadataRows,
            hasMultipleParts
        };
    } else { // Valid metadata not found
        return {
            success: false,
            errorMessage: 'Validation cells do not match.'
        };
    }
}

function findMetadata(cmmConfig: CmmConfig, table: string[][]) {
    let foundMetadata = false;
    let hasMultipleParts = false;
    let lastMetadataStart = null;

    let startRow = 0;
    while (startRow + cmmConfig.metadataRows <= table.length) {

        let validationsMatch = true;
        for (const validationCell of cmmConfig.validationCells) {
            const actual = table[startRow + validationCell.row][validationCell.column];
            validationsMatch &&= (actual === validationCell.value);
        }

        if (validationsMatch) {
            hasMultipleParts = foundMetadata;
            lastMetadataStart = startRow;
            foundMetadata = true;
        }
        startRow++;
    }
    return {
        foundMetadata,
        lastMetadataStart,
        hasMultipleParts
    };
}

